import { createReducer } from '@reduxjs/toolkit';
import {
  requestPreferenceList,
  requestPreferenceListFailure,
  requestPreferenceListSuccess,
  requestPreferenceByBanner,
  requestPreferenceByBannerFailure,
  requestPreferenceByBannerSuccess,
} from 'redux/actions/actions';
import {
  RequestPreferenceByBannerAction,
  RequestPreferenceByBannerSuccessAction,
  RequestPreferenceByBannerFailureAction,
} from 'redux/actions/type';
import { preferenceInit } from 'redux/reducers/init';

const preference = createReducer(preferenceInit, {
  [requestPreferenceList.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestPreferenceListSuccess.type]: (state, action) => {
    const { video, videoLibrary } = action.payload;
    state.isLoading = false;
    state.isInit = true;
    state.preferences.video = video;
    state.preferences.videoLibrary = videoLibrary;
  },
  [requestPreferenceListFailure.type]: (state, action) => {
    state.isLoading = false;
    state.isInit = false;
    state.preferences = {
      video: null,
      videoLibrary: null,
      banner: null,
    };
  },
  [requestPreferenceByBanner.type]: (state, action: RequestPreferenceByBannerAction) => {},
  [requestPreferenceByBannerSuccess.type]: (
    state,
    action: RequestPreferenceByBannerSuccessAction,
  ) => {
    const { banner } = action.payload;
    state.preferences.banner = banner;
  },
  [requestPreferenceByBannerFailure.type]: (
    state,
    action: RequestPreferenceByBannerFailureAction,
  ) => {
    state.preferences.banner = null;
  },
});

export default preference;
